import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductEnhancementDocument.Find.IRequest;
type Response = Api.Core.ProductEnhancementDocument.Find.IResponse;
type Headers = Api.Core.ProductEnhancementDocument.Find.IHeaders;
const url = '/api/ProductManagement/ProductEnhancementDocument/:id';
export default async function productEnhancementDocumentFindApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
